export class BaseAdapter {
  static adapt(res: any) {
    // if (!res) throw new Error('Unable to adapt the OperationStatus');
    // return {} as any
  }
}
